import React, { PureComponent } from 'react'
import styled, { keyframes, css } from 'styled-components'

const ANIMATION_DURATION = 3

const spinningAnim = keyframes`
  0% {
    transform: rotate(0deg) ;
  }
  100% {
    transform: rotate(360deg) ;
  }
`

const scalingAnim = keyframes`
  0% {
    transform: scale(1, 1) ;
  }
  50% {
    transform: scale(0.75, 0.75) ;
  }
  100% {
    transform: scale(1, 1) ;
  }
`

const Wrapper = styled.div<{ $areAnimationsEnabled: boolean }>`
	width: 100%;
	height: 100%;
	position: relative;
	background-color: rgba(255, 255, 0, 0);
	${(props) =>
		props.$areAnimationsEnabled &&
		css`
			animation: ${spinningAnim} ${ANIMATION_DURATION}s;
			animation-iteration-count: infinite;
			animation-timing-function: linear;
		`}
`

const LoadingAnimationDot = styled.div<{ $areAnimationsEnabled: boolean }>`
	width: 25%;
	height: 25%;
	${(props) =>
		props.$areAnimationsEnabled &&
		css`
			animation: ${scalingAnim} ${ANIMATION_DURATION}s;
			animation-iteration-count: infinite;
			animation-timing-function: linear;
		`}
	border-radius: 50%;
	background-color: rgb(255, 255, 255);
`

const LoadingAnimationContainer = styled.div`
	width: 100%;
	height: 100%;
	position: absolute;
	top: 0;
	left: 0;
`

interface ILoadingWheelProps {
	areAnimationsEnabled?: boolean
}

class LoadingWheel extends PureComponent<ILoadingWheelProps> {
	buildLoadingDots() {
		const areAnimationsEnabled = this.props.areAnimationsEnabled !== false
		let i = 8
		const dots = []
		while (i) {
			const dot = (
				<LoadingAnimationContainer key={i} style={{ transform: `rotate(${(i * 360) / 8}deg` }}>
					<LoadingAnimationDot
						$areAnimationsEnabled={areAnimationsEnabled}
						style={{ animationDelay: `${((8 - i) * ANIMATION_DURATION) / 8}s` }}
					/>
				</LoadingAnimationContainer>
			)
			dots.push(dot)
			i -= 1
		}
		return dots
	}

	render() {
		const areAnimationsEnabled = this.props.areAnimationsEnabled !== false
		return <Wrapper $areAnimationsEnabled={areAnimationsEnabled}>{this.buildLoadingDots()}</Wrapper>
	}
}

export default LoadingWheel
